const welcomeObject = {
    configName: 'welcome',
    container: null,
    leftSideContainer: null,
    rightSideContainer: null,
    plxElement: null,
    plxCurrentTop: 0,
    plxFactorSpeed: 0.02,
    plxPercentage: 0.1,
    plxSpeed: 6,
    height: null,
    status: -1,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;
        this.container = document.querySelector('.welcome');
        this.leftSideContainer = this.container.querySelector('.welcome-icons__left-side');
        this.rightSideContainer = this.container.querySelector('.welcome-icons__right-side');

        this.plxElement = document.querySelector('.welcome-phone');
        this.height = this.plxElement.getBoundingClientRect().height;
        main.setLoaderPercent(1);
    },
    reactToScroll: function (data) {
        if (window.innerWidth >= main.mobileResolutionBorder && data.isVisible) {
            if (this.height === 0) this.height = this.plxElement.getBoundingClientRect().height;

            this.container.style.transform = 'translate3d(0,' + Math.round(-data.globalOffset * 100) / 100 + 'px , 0)';

            this.plxCurrentTop += (data.localScroll * this.plxFactorSpeed * this.plxSpeed - this.plxCurrentTop) * this.plxPercentage;
            const offsetY = (-this.height / 2) - Math.round(this.plxCurrentTop * 100) / 100;

            if (offsetY >= -this.height / 2 || !data.isVisible) {
                this.reactToResize();
            } else {
                this.plxElement.style.transform = 'translate3d(-50%, ' + offsetY + 'px, 0)';
                this.leftSideContainer.style.transform = 'translate3d(' + -this.plxCurrentTop + 'px, ' + -this.plxCurrentTop + 'px, 0)';
                this.rightSideContainer.style.transform = 'translate3d(' + this.plxCurrentTop + 'px, ' + -this.plxCurrentTop + 'px, 0)';
            }
        }

        const canvasInstance = riveHeaderAnimationObject.instance;

        if (canvasInstance !== null) {
            if (data.isVisible) {
                canvasInstance.startRendering();
                canvasInstance.play();
                canvasInstance.canvas.style.opacity = '1';
            } else {
                canvasInstance.stopRendering();
                canvasInstance.canvas.style.opacity = '0';
            }
        }
    },
    reactToResize: function () {
        this.height = this.plxElement.getBoundingClientRect().height;
        this.container.style.transform = '';
        this.plxElement.style.transform = '';
        this.leftSideContainer.style.transform = '';
        this.rightSideContainer.style.transform = '';
        this.plxCurrentTop = 0;
    },
};
